import { requestGet, requestPut } from '../request';
import apiPath from './apiPath';
const api = {
  GetWaitingData(payload) {
    return requestGet(apiPath.GET_WAITING_LIST.path, payload);
  },

  UpdateWaiting(payload) {
    return requestPut(apiPath.UPDATE_WAITING.path, payload);
  },

  GetNewWaiting(payload) {
    return requestGet(apiPath.GET_NEW_WAITING.path, payload);
  },
};

export default api;
